// extracted by mini-css-extract-plugin
export default {"root":"RJimAihtGc","root_hasTransition":"izS2K1xNAf","coveredItemsContainer":"YOrzG1ZwZB","itemWrapper":"y2g5DFL7tT","itemWrapper_hasTransition":"fhxci7C8gF"};